import * as React from "react";
import ArticleForm from "../shared/ArticleForm";
import useModelState from "../hooks/useModelState";
import useArticleFormModel from "../hooks/useArticleFormModel";
import PreviewButton from "./PreviewButton";
import useApi from "@/hooks/useApi";
import {
  PrimaryBlueButton,
  SecondaryBlueButton
} from "@velaro/velaro-component-lib";

export default function Create() {
  const [saving, setSaving] = React.useState(false);
  const [article, setArticle] = useArticleFormModel();
  const [modelState, setModelState] = useModelState();
  const api = useApi();

  async function save(publish: boolean) {
    setSaving(true);
    try {
      const resp = await api.admin.post("api/kb/articles", {
        ...article,
        isPublished: publish
      });

      if (resp.status === 400) {
        console.error(resp);
        setSaving(false);
        return;
      }

      window.location.href = "/kb/articles";
    } catch (err) {
      console.error("Failed to save article:", err);
      setSaving(false);
    }
  }

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold text-slate-800">
          New Article
        </h1>
        <PreviewButton title={article.title} content={article.content} />
      </div>

      <ArticleForm
        article={article}
        onChange={(props) => {
          setArticle((oldState) => ({ ...oldState, ...props }));
        }}
        modelState={modelState}
      />

      <div className="flex items-center gap-3 mt-6 pt-4 border-t">
        <SecondaryBlueButton
          label={saving ? "Saving..." : "Save Draft"}
          disabled={saving}
          onClick={() => save(false)}
        />
        <PrimaryBlueButton
          label={saving ? "Saving..." : "Save and Publish"}
          disabled={saving}
          onClick={() => save(true)}
        />
        <a
          href="/kb/articles"
          className="text-sm text-slate-500 hover:text-slate-700 ml-2"
        >
          Back to Articles
        </a>
      </div>
    </div>
  );
}
